import logo from "../../../assets/Logo.png";
import userIcon from "../../../assets/userIcon.png";
import "./navBar.scss";
import LocationSearchBar from "./locationSearchBar";
import { useEffect, useState, useRef } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate, useLocation } from "react-router-dom";
import RefreshToken from "./RefreshToken";
import { IoNotifications } from "react-icons/io5";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useDispatch } from "react-redux";

function Navbar(props) {
  const { showLocationSearchBar = true, setInputAddressLabel } = props;
  const [name, setName] = useState("");
  const [MenuBarResturant, setMenuBarResturant] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const restaurant_existence = localStorage.getItem("restaurant_existence");
  const [notifications, setNotifications] = useState(
    JSON.parse(localStorage.getItem("notifications"))
  );
  const [showNotifications, setShowNotifications] = useState(false);
  const [showNotificationsDetails, setShowNotificationsDetails] =
    useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
    const restaurant_existence = localStorage.getItem("restaurant_existence");
    if (restaurant_existence) {
      setMenuBarResturant("My restaurant");
    } else {
      setMenuBarResturant("Add restaurant");
    }
    setShowNotifications(false);
  };

  const handlePageClick = (event) => {
    if (isMenuOpen && !event.target.closest(".dropdown-menu")) {
      setIsMenuOpen(false);
    }

    if (
      showNotifications &&
      !event.target.closest(".notifications-container")
    ) {
      setShowNotifications(false);
    }
  };

  window.addEventListener("click", handlePageClick);
  // useEffect(() => {}, [notifications]);
  useEffect(() => {
    console.log(typeof setInputAddressLabel);

    console.log({ token });
    if (token) {
      const decodedToken = jwt_decode(token);
      setName(decodedToken.name_surname);
      setMenuBarResturant(decodedToken.menubar_restaurant);
    }
  }, [token, restaurant_existence]);
  const logout = () => {
    fetch("https://femez.onrender.com/API/user/logOut", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setName("");
          setIsLoggingOut(false);
        }
        return res.json();
      })
      .then((data) => {
        localStorage.removeItem("token");
        localStorage.removeItem("restaurant_existence");
        localStorage.removeItem("refreshed");
        localStorage.removeItem("location");
        localStorage.removeItem("inputAddressLabel");

        // localStorage.removeItem("notifications");
        sessionStorage.removeItem("favorites");
        sessionStorage.removeItem("restaurants");
        sessionStorage.removeItem("restaurantClicked");
        sessionStorage.removeItem("orderedDishes");
        sessionStorage.removeItem("total");

        dispatch({
          type: "HANDLECHANGE",
          payload: {
            location: "",
          },
        });
        setShowNotifications(false);
        navigate(`/`);
        console.log(data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const LogIn = () => {
    navigate(`/logIn`);
  };
  const updateUserData = () => {
    navigate(`/user/updateUser`);
    setIsMenuOpen(false);
  };
  const goToHomePage = () => {
    if (token) {
      navigate(`/restaurants`);
    } else if (location.pathname !== "/restaurants") {
      navigate(`/`);
    }
  };

  const goToAddRestaurant = () => {
    console.log(MenuBarResturant);
    if (MenuBarResturant === "Add restaurant") {
      navigate(`/restaurant/addRestaurant`);
      setIsMenuOpen(false);
    } else if (MenuBarResturant === "My restaurant") {
      navigate(`/restaurant/myRestaurant`);
      setIsMenuOpen(false);
    }
  };
  const goToHistory = () => {
    navigate(`/restaurant/myOrdersHistory`);
    setIsMenuOpen(false);
  };
  const handleNotifications = () => {
    setIsMenuOpen(false);
    setShowNotifications(!showNotifications);
    console.log({ showNotifications });

    console.log("notifications clicked");
    let notifications = JSON.parse(localStorage.getItem("notifications")) || [];

    const currentTime = new Date().getTime();

    // Iterate through notifications
    notifications = notifications.filter((notification) => {
      const notificationTime = notification[2]; // assuming index 2 contains the timestamp
      console.log(notificationTime);
      const timeDifferenceInSeconds = (currentTime - notificationTime) / 1000;
      console.log(timeDifferenceInSeconds);
      notification[4] = timeDifferenceInSeconds;
      const expirationTimeInSeconds = (notification[3] + 20) * 60; //  index 3 contains the expiration time in minutes
      console.log(expirationTimeInSeconds);

      // Check if the time difference is greater than the expiration time
      if (timeDifferenceInSeconds > expirationTimeInSeconds) {
        return false; // Remove the notification
      }

      return true; // Keep the notification
    });
    setNotifications(notifications);
    // Update the local storage with the modified notifications
    localStorage.setItem("notifications", JSON.stringify(notifications));

    console.log(notifications);
  };
  const handleViewDetailsClick = (notification) => {
    setSelectedNotification(notification);
    setShowNotifications(false);
    setShowNotificationsDetails(true);

    console.log(notification);
  };

  return (
    <div>
      <div className="navbar">
        <div
          className="logo"
          onClick={() => {
            goToHomePage();
          }}
        >
          <img className="img" src={logo} alt="Logo" />
        </div>
        {showLocationSearchBar && (
          <LocationSearchBar
            autofocusProp={false}
            setInputAddressLabel={setInputAddressLabel}
          />
        )}

        <div className="name-menu">
          {name !== "" && (
            <div className="notifications-icon">
              <IoNotifications
                onClick={(e) => {
                  e.stopPropagation();
                  handleNotifications();
                }}
              />
              {notifications && notifications.length > 0 && (
                <div className="red-dot"></div>
              )}
            </div>
          )}
          {name !== "" && (
            <img
              onClick={updateUserData}
              className="img"
              src={userIcon}
              alt="userIcon"
            />
          )}

          <i
            className="fa fa-regular fa-bars"
            onClick={(event) => {
              event.stopPropagation();
              handleMenuClick();
            }}
          ></i>
        </div>
        {isMenuOpen && (
          <div className="dropdown-menu">
            {/* Dropdown menu content */}
            <ul>
              {name !== "" && (
                <>
                  {" "}
                  <li onClick={updateUserData}>My profile</li>
                  <li onClick={goToAddRestaurant}>{MenuBarResturant}</li>
                  <li onClick={goToHistory}>My orders history</li>
                  <li onClick={logout}>Logout</li>
                </>
              )}
              {name === "" && <li onClick={LogIn}>LogIn</li>}
            </ul>
          </div>
        )}
        {showNotifications && name !== "" && (
          <div className="notifications-container">
            {notifications.length > 0 ? (
              <div>
                {notifications.map((notification, notificationIndex) => (
                  <div className="notification" key={notificationIndex}>
                    <div>
                      Ordered from the restaurant:
                      <div className="restaurant-name"> {notification[0]} </div>
                    </div>
                    <div className="estimated-time">
                      <div>Estimated delivery time</div>
                      <CountdownCircleTimer
                        isPlaying
                        duration={(notification[3] + 20) * 60}
                        initialRemainingTime={
                          notification[2]
                            ? (notification[3] + 20) * 60 -
                              Math.floor(notification[4])
                            : (notification[3] + 20) * 60
                        }
                        colors={["#007664"]}
                        size={80}
                        strokeWidth={7}
                      >
                        {({ remainingTime }) => {
                          const minutes = Math.floor(remainingTime / 60);
                          const seconds = remainingTime % 60;
                          return (
                            <div style={{ textAlign: "center" }}>
                              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}{" "}
                              <div>Minutes</div>
                            </div>
                          );
                        }}
                      </CountdownCircleTimer>
                    </div>
                    <div
                      className="view-details"
                      onClick={() => handleViewDetailsClick(notification)}
                    >
                      View order details
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div>No notifications !</div>
            )}
          </div>
        )}
        {showNotificationsDetails && (
          <div className="notification-details-container">
            <div className="notification-details">
              <h2>Order Details</h2>
              <div className="restaurant-name-container">
                Ordered from the restaurant:
                <p className="restaurant-name"> {selectedNotification[0]}</p>
              </div>
              <div className="order-time-container">
                Order placed at:
                <p className="order-time">
                  {new Date(selectedNotification[2]).toLocaleTimeString()},{" "}
                  {selectedNotification[6]}
                </p>
              </div>
              <div className="order-dishes-container">
                <p className="title">Order summary</p>
                {selectedNotification[1].map((item, index) => (
                  <div key={index} className="order-dishes">
                    <p>
                      {item.dish.dish_name}({item.count})
                    </p>
                    <p key={index}>{item.dish.dish_price * item.count} €</p>
                  </div>
                ))}
                <div className="order-dishes-total-price">
                  <p>Total order price:</p>{" "}
                  <p className="total-price">{selectedNotification[5]} €</p>
                </div>
              </div>

              <button
                className="close-button"
                onClick={() => setShowNotificationsDetails(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <RefreshToken token={token} isLoggingOut={isLoggingOut} />
    </div>
  );
}

export default Navbar;
